const isDevelopment = process.env.NODE_ENV === 'development';

function getApiBaseUrl() {
  if (isDevelopment) {
    return '/api/v1';
  }
  if (process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/v1`;
  }
  return '/api/v1';
}

function shellSingleQuotedSegment(value) {
  return `'${value.replace(/'/g, "'\\''")}'`;
}

/**
 * Monta um comando cURL equivalente ao multipart enviado pelo formulário.
 * O caminho em `file=@...` é ilustrativo: substitua pelo arquivo real no disco.
 */
export function buildProcessDocumentCurl(input) {
  const url = `${getApiBaseUrl()}/idp/documents/process`;
  const filePath = `./${input.file.name.replace(/\\/g, '/')}`;
  const lines = [
    `curl -sS -X POST ${shellSingleQuotedSegment(url)} \\`,
    `  -F ${shellSingleQuotedSegment(`file=@${filePath}`)} \\`,
    `  -F ${shellSingleQuotedSegment(`mimeType=${input.mimeType}`)} \\`,
    `  -F ${shellSingleQuotedSegment(`expectedClasses=${JSON.stringify(input.expectedClasses)}`)} \\`,
    `  -F ${shellSingleQuotedSegment(`classificationThreshold=${String(input.classificationThreshold)}`)}`,
  ];
  if (input.options && Object.keys(input.options).length > 0) {
    lines[lines.length - 1] += ' \\';
    lines.push(
      `  -F ${shellSingleQuotedSegment(`options=${JSON.stringify(input.options)}`)}`,
    );
  }
  return lines.join('\n');
}
